const configs = {
    fallSpeed: 15,
    bounceSpeed:7.5,
    bounceDeviationRange:[1, 2],
    bounceHeightRange:[0.3, 0.6],
    ballRadius:25,
    rollingSpeed:1.5,
    stopHeightExtra:50,
    colorsPerBall:5,
    info: "This game resembles balls falling and then bouncing due to Earth's graviation.Click anywhere in the game to watch balls fall and bounce.",
    infoImage: "/bounceFall/gravitation.png",
    infoImage2: "/oceanFlow/mouse.png",
    mouseExtraX: 2.5,
    mouseExtraY: 5,
    colors:["red", "black", "green", "white",
        "purple", "orangered", "gold", "blue",
        "grey", "orange", "yellow", "olive", "cyan"]
}

export default configs;